import { render, staticRenderFns } from "./loginCertify.vue?vue&type=template&id=0d5ff06c&scoped=true"
import script from "./loginCertify.vue?vue&type=script&lang=js"
export * from "./loginCertify.vue?vue&type=script&lang=js"
import style0 from "./loginCertify.vue?vue&type=style&index=0&id=0d5ff06c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d5ff06c",
  null
  
)

export default component.exports